import type { SVGProps } from 'react';

export const DatabasesIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg width={28} viewBox="1 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M28.9465 21.5V28H16.4465V21.5H28.9465ZM28.9465 18.5V12.5H16.4465V18.5H28.9465ZM28.9465 9.5V0H0.946533V9.5H28.9465ZM0.946533 12.5V18.5H13.4465V12.5H0.946533ZM0.946533 21.5H13.4465V28H0.946533V21.5Z"
			fill="currentColor"
		/>
	</svg>
);
